'use client';

import { c as _c } from "react/compiler-runtime";
import { composeSelectedFontObject } from '../helpers';
import StreambotWrapper from '../StreambotWrapper';
import { SOUND_VOLUME, milestonesDemoData } from './constants';
import getDefaultValues from './getDefaultValues';
import Milestone from './Milestone';
import { MilestoneDisplayMode, type MilestonesWidgetProps } from './types';
import useMilestones from './useMilestones';
import useGoogleFonts from '@/fonts/useGoogleFonts';
function Milestones(t0) {
  const $ = _c(45);
  let dataFont;
  let dataFontColor;
  let dataFontSize;
  let dataFontWeight;
  let demoData;
  let fundraisingEventId;
  let headlineFont;
  let headlineFontColor;
  let headlineFontSize;
  let headlineFontWeight;
  let previewDonationData;
  let realMilestonesData;
  let showMilestoneDetails;
  let t1;
  let t2;
  let t3;
  let withDemoData;
  let wrapperProps;
  if ($[0] !== t0) {
    const {
      demoData: t4,
      previewDonationData: t5,
      withDemoData: t6,
      fundraisingEventId: t7,
      ...props
    } = t0;
    previewDonationData = t5;
    withDemoData = t6;
    fundraisingEventId = t7;
    demoData = t4 === undefined ? milestonesDemoData : t4;
    const mergedProps = getDefaultValues(props);
    const {
      mode,
      headlineFont: t8,
      headlineFontColor: t9,
      headlineFontSize: t10,
      headlineFontWeight: t11,
      dataFont: t12,
      dataFontColor: t13,
      dataFontSize: t14,
      dataFontWeight: t15,
      milestoneItems: t16,
      ...t17
    } = mergedProps;
    headlineFont = t8;
    headlineFontColor = t9;
    headlineFontSize = t10;
    headlineFontWeight = t11;
    dataFont = t12;
    dataFontColor = t13;
    dataFontSize = t14;
    dataFontWeight = t15;
    realMilestonesData = t16;
    wrapperProps = t17;
    showMilestoneDetails = mode !== MilestoneDisplayMode.AlertOnly;
    t3 = useGoogleFonts;
    t1 = composeSelectedFontObject(headlineFont, headlineFontWeight);
    t2 = composeSelectedFontObject(dataFont, dataFontWeight);
    $[0] = t0;
    $[1] = dataFont;
    $[2] = dataFontColor;
    $[3] = dataFontSize;
    $[4] = dataFontWeight;
    $[5] = demoData;
    $[6] = fundraisingEventId;
    $[7] = headlineFont;
    $[8] = headlineFontColor;
    $[9] = headlineFontSize;
    $[10] = headlineFontWeight;
    $[11] = previewDonationData;
    $[12] = realMilestonesData;
    $[13] = showMilestoneDetails;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = withDemoData;
    $[18] = wrapperProps;
  } else {
    dataFont = $[1];
    dataFontColor = $[2];
    dataFontSize = $[3];
    dataFontWeight = $[4];
    demoData = $[5];
    fundraisingEventId = $[6];
    headlineFont = $[7];
    headlineFontColor = $[8];
    headlineFontSize = $[9];
    headlineFontWeight = $[10];
    previewDonationData = $[11];
    realMilestonesData = $[12];
    showMilestoneDetails = $[13];
    t1 = $[14];
    t2 = $[15];
    t3 = $[16];
    withDemoData = $[17];
    wrapperProps = $[18];
  }
  let t4;
  if ($[19] !== t1 || $[20] !== t2) {
    t4 = {
      fonts: [t1, t2]
    };
    $[19] = t1;
    $[20] = t2;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  t3(t4);
  const milestonesData = withDemoData ? demoData : realMilestonesData;
  const {
    currentMilestone,
    shouldPlay,
    onPlaybackStart,
    onPlaybackComplete,
    lastMilestoneReached
  } = useMilestones(fundraisingEventId, milestonesData, previewDonationData, withDemoData);
  const t5 = !shouldPlay;
  let t6;
  if ($[22] !== currentMilestone.amountInCents || $[23] !== currentMilestone.gifUrl || $[24] !== currentMilestone.id || $[25] !== currentMilestone.soundUrl || $[26] !== dataFont || $[27] !== dataFontColor || $[28] !== dataFontSize || $[29] !== dataFontWeight || $[30] !== demoData || $[31] !== headlineFont || $[32] !== headlineFontColor || $[33] !== headlineFontSize || $[34] !== headlineFontWeight || $[35] !== lastMilestoneReached || $[36] !== onPlaybackComplete || $[37] !== onPlaybackStart || $[38] !== showMilestoneDetails || $[39] !== t5 || $[40] !== withDemoData) {
    t6 = <Milestone onPlaybackStart={onPlaybackStart} onPlaybackComplete={onPlaybackComplete} demoData={demoData} withDemoData={withDemoData} headlineFont={headlineFont} headlineFontColor={headlineFontColor} headlineFontSize={headlineFontSize} headlineFontWeight={headlineFontWeight} dataFont={dataFont} dataFontColor={dataFontColor} dataFontSize={dataFontSize} dataFontWeight={dataFontWeight} volume={SOUND_VOLUME} skipPlayback={t5} showMilestoneDetails={showMilestoneDetails} id={currentMilestone.id} amountInCents={currentMilestone.amountInCents} gifUrl={currentMilestone.gifUrl} soundUrl={currentMilestone.soundUrl} lastMilestoneReached={lastMilestoneReached} />;
    $[22] = currentMilestone.amountInCents;
    $[23] = currentMilestone.gifUrl;
    $[24] = currentMilestone.id;
    $[25] = currentMilestone.soundUrl;
    $[26] = dataFont;
    $[27] = dataFontColor;
    $[28] = dataFontSize;
    $[29] = dataFontWeight;
    $[30] = demoData;
    $[31] = headlineFont;
    $[32] = headlineFontColor;
    $[33] = headlineFontSize;
    $[34] = headlineFontWeight;
    $[35] = lastMilestoneReached;
    $[36] = onPlaybackComplete;
    $[37] = onPlaybackStart;
    $[38] = showMilestoneDetails;
    $[39] = t5;
    $[40] = withDemoData;
    $[41] = t6;
  } else {
    t6 = $[41];
  }
  let t7;
  if ($[42] !== t6 || $[43] !== wrapperProps) {
    t7 = <StreambotWrapper {...wrapperProps}>{t6}</StreambotWrapper>;
    $[42] = t6;
    $[43] = wrapperProps;
    $[44] = t7;
  } else {
    t7 = $[44];
  }
  return t7;
}
export default Milestones;